import { EditorState, Selection } from 'prosemirror-state'

export function injectContent(state: EditorState, selection: Selection, contentToInject: string) {
  // Create a new transaction
  let tr = state.tr

  // Determine the position to insert the content
  const insertPos = selection.head || 0

  // Create a node from the content to inject
  const node = state.schema.text(contentToInject)

  // Insert the node
  tr = tr.insert(insertPos, node)

  // Return the new document after applying the transaction
  return tr.doc
}
